<template>
  <div v-if="camera.inst" class="flex justify-end pr-3 pb-8">
    <vue-slider :height="130"
                :width="1"
                :min="15"
                :max="165"
                :process="false"
                :tooltip="'none'"
                :dotStyle="dotStyle"
                :railStyle="railStyle"
                :interval="0.1"
                @change="render"
                v-model="camera.inst.position.y"
                direction="btt"></vue-slider>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import VueSlider from 'vue-slider-component'
  export default {
    name: "CameraPositionYController",
    components: {
      VueSlider
    },
    data() {
      return {
        dotStyle: {
          backgroundColor: 'red'
        },
        railStyle: {
          backgroundColor: 'black',
        }
      }
    },
    computed: {
      ...mapGetters('camera',[
        'camera',
      ])
    },
    methods: {
      ...mapActions([
        'render'
      ])
    }
  }
</script>

<style scoped>

</style>